import React, { useMemo } from 'react';
import type { HardwareGuides } from '../../assets/hardwareGuides';
import type { HardwareProduct } from '../../hardware/hardwareCatalog';
import { placeHardwareAt } from '../../hardware/placeHardware';
import { PlacedHardwareArtwork } from './PlacedHardwareArtwork';
import { useHardwareArtwork } from './useHardwareArtwork';

/**
 * Fetch one catalogue product and sit its authored origin on the named slab guide.
 * Point anchors and letterplate zones both resolve through `placeHardwareAt`.
 */
export const ConfiguredHardwareArtwork: React.FC<{
  product: HardwareProduct;
  placementId: string;
  slabGuides: HardwareGuides;
}> = ({ product, placementId, slabGuides }) => {
  const artwork = useHardwareArtwork(product.publicPath);
  const placement = useMemo(
    () => placeHardwareAt(slabGuides, artwork, product, placementId),
    [artwork, placementId, product, slabGuides]
  );

  if (!placement) return null;
  return <PlacedHardwareArtwork placement={placement} />;
};
